import { arrow } from "@popperjs/core";
import {
  ErrorToast,
  SuccessToast,
} from "app/shared/components/Popups/ToastMessage";
import React, { useEffect, useState } from "react";
import { Form, Button, Modal } from "react-bootstrap";
import { BiLaptop } from "react-icons/bi";
import Url from "app/shared/constants/Url";
import Axios from "axios";
import { useHistory } from "react-router-dom";
import { convertDateToUTC } from "app/shared/utility/tzUtilFunction";

function ApproveRejectModal({
  show,
  handleClose,
  approveData,
  status,
  openList,
  reportingScreen,
}) {
  const [category, setCategory] = useState("");
  const [categories, setCategories] = useState([]);

  const [manualDueDate, setManualDueDate] = useState("");
  const [remark, setRemark] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const approverApiUrl = Url.soiDashboard.postReview.approveReject;
  const categoriesApiUrl = Url.soiDashboard.postReview.categoryList;
  const history = useHistory();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const params = {
          categoryType: status === "Approve" ? "APPROVE" : "REJECT",
          user_id: localStorage.getItem("userId"),
          auth_key: localStorage.getItem("springToken"),
        };

        const response = await Axios.get(categoriesApiUrl, { params });

        if (response.data.status === 200) {
          // only keep categories where softDelete == 0
          const validCategories = response.data.data?.filter(
            (cat) => cat.softDelete === 0,
          );
          setCategories(validCategories);
        } else {
          console.error("Error fetching categories:", response.data.message);
          setCategories([]);
        }
      } catch (error) {
        console.error("API Error:", error);
        setCategories([]);
      }
    };

    fetchCategories();
  }, [status]);

  useEffect(() => {
    if (approveData?.dueDate) {
      const d = new Date(approveData.dueDate);

      // Format into YYYY-MM-DDTHH:mm
      const formattedDate =
        d.getFullYear() +
        "-" +
        String(d.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(d.getDate()).padStart(2, "0") +
        "T" +
        String(d.getHours()).padStart(2, "0") +
        ":" +
        String(d.getMinutes()).padStart(2, "0");

      setManualDueDate(formattedDate);
    }
  }, [approveData]);

  // Utility function
  const formatDateTime = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  const submitApprove = async (e) => {
    if (e) e.preventDefault();

    try {
      setIsLoading(true);

      const payload = {
        auth_key: localStorage.getItem("springToken"),
        user_id: localStorage.getItem("userId"),
        uaucId: approveData?.uaucId,
        action: status === "Approve" ? "approve" : "reject",
        categoryId: category,
        remark: remark,
        riskBaseDueDate: formatDateTime(manualDueDate),
        // riskBaseDueDate: convertDateToUTC(manualDueDate),
      };

      if (remark.trim() === "") {
        ErrorToast("Remark is required");
        setIsLoading(false);
        return;
      }

      const response = await Axios.put(approverApiUrl, {}, { params: payload });
      setIsLoading(false);

      if (response.data.status === 200) {
        // Dynamic success message
        SuccessToast(
          status === "Approve"
            ? "Approved successfully"
            : "Rejected successfully",
        );
        if (approveData.reportingScreen == "preReview") {
          // if (status == "Reject") {
          //   history.push({
          //     pathname: "/ua-uc/dashboard",
          //     state: { activeTab: "preReview" },
          //   });
          //   return;
          // }

          history.push({
            pathname: "/ua-uc/dashboard",
            state: { activeTab: "preReview" },
          });
          return;
        }
        if (approveData.reportingScreen == "postReview") {
          // if (status == "Reject") {
          //   history.push({
          //     pathname: "/ua-uc/dashboard",
          //     state: { activeTab: "postReview" },
          //   });
          //   return;
          // }

          history.push({
            pathname: "/ua-uc/dashboard",
            state: { activeTab: "postReview" },
          });
          return;
        }

        if (typeof openList === "function") {
          openList(1, "PROJECT");
        }

        handleClose();
        //window.location.reload();
      } else {
        ErrorToast(response.data.message || "Error while processing request");
      }
    } catch (error) {
      setIsLoading(false);

      if (error.response?.status === 409) {
        ErrorToast(error.response.data.msg);
        console.log("Approval Conflict:", error.response.data);
      } else {
        ErrorToast(
          status === "Approve"
            ? "Error while approving"
            : "Error while rejecting",
        );
        console.error(error);
      }
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton className="justify-content-center border-0">
        <div className="d-flex flex-column align-items-center w-100">
          <div
            style={{
              width: 36,
              height: 36,
              borderRadius: "50%",
              background: "#f2f4f6",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: 8,
            }}
          >
            <BiLaptop size={24} />
          </div>
          <div
            className="clide-v2-primary-color"
            style={{ fontWeight: 600, fontSize: 20, textAlign: "center" }}
          >
            {status} UAUC Observation
          </div>
        </div>
      </Modal.Header>

      <Modal.Body>
        {status == "Approve" ? (
          <div style={{ textAlign: "center", color: "#868e96", fontSize: 15 }}>
            Approving this request will notify the applicant and update the
            status to Approved. This action is final and cannot be undone.
          </div>
        ) : (
          <div style={{ textAlign: "center", color: "#868e96", fontSize: 15 }}>
            Rejecting this request will notify the applicant and mark the
            request as Rejected. The reporter will be allowed to resubmit after
            rejection; this action cannot be undone.
          </div>
        )}

        <Form className="mt-2">
          <div className="row g-3">
            {" "}
            {/* g-3 adds spacing between columns */}
            <div
              className={
                status == "Approve" && reportingScreen !== "postReview"
                  ? `col-md-3`
                  : `col-md-6`
              }
            >
              <Form.Group controlId="uaucReportId">
                <Form.Label className="fw-bold">UAUC ID</Form.Label>
                <Form.Control
                  type="text"
                  value={approveData ? `#${approveData.uaucId}` : "-"}
                  disabled
                />
              </Form.Group>
            </div>
            <div
              className={
                status == "Approve" && reportingScreen !== "postReview"
                  ? `col-md-4`
                  : `col-md-6`
              }
            >
              <Form.Group controlId="category">
                <Form.Label className="fw-bold">Category</Form.Label>
                <select
                  className="form-control"
                  value={category}
                  onChange={(e) => setCategory(e.target.value)}
                >
                  <option value="">Select Category</option>
                  {categories.map((cat) => (
                    <option key={cat.id} value={cat.id}>
                      {cat.category}
                    </option>
                  ))}
                </select>
              </Form.Group>
            </div>
            {status == "Approve" && reportingScreen !== "postReview" && (
              <div className="col-md-5">
                <Form.Group controlId="manualDueDate">
                  <Form.Label className="fw-bold">
                    {approveData.isRiskBaseDueDate
                      ? "Risk Based Date"
                      : "Manual Due Date"}
                  </Form.Label>
                  <Form.Control
                    type="datetime-local"
                    value={manualDueDate}
                    disabled={approveData.isRiskBaseDueDate}
                    onChange={(e) => setManualDueDate(e.target.value)}
                  />
                </Form.Group>
              </div>
            )}
          </div>

          {/* Remark field stays full width */}
          <Form.Group className="mt-2" controlId="remark">
            <Form.Label className="fw-bold">Remark</Form.Label>
            <Form.Control
              type="text"
              placeholder={
                status === "Approve"
                  ? "Enter approval remark here........."
                  : "Enter rejection remark here........."
              }
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Form
        className="mt-2"
        // onSubmit={handleApprove}
      >
        {/* Form groups */}
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            // disabled={!category || !remark.trim()}
            className="clide-v2-primary"
            onClick={submitApprove}
          >
            {status}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default ApproveRejectModal;
